<template>
  <div class="card" style="min-height: calc(100vh - 180px)">
    <div class="bg-blue-light p-1">
      <TitleButton
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          title="Edit Product Costing"
          @onClickCloseButton="navigateToListPage"
      />
      <div class="row gy-1">
        <div class="col-md-4">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="form-label">Customer Name: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                  <i class="fas fa-search"></i>
              </span>
            </div>

            <AsyncSelect
                placeholder="Select Customer"
                v-model="contactProfile"
                :api-service="fetchContactProfiles"
                :format-label="formatPatientLabel"
                class="flex-grow-1"
                :additional-query="{type: 'customer'}"
            />
          </div>
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="form-label">Buyer Name: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                  <i class="fas fa-search"></i>
              </span>
            </div>

            <AsyncSelect
                placeholder="Select Buyer"
                v-model="buyerProfile"
                :api-service="fetchContactProfiles"
                :format-label="formatPatientLabel"
                class="flex-grow-1"
                :additional-query="{type: 'buyer'}"
            />
          </div>
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="hidden col-md-4">
              <label for="colFormLabel" class="form-label">Sample Ref & Date: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder="Sample Ref & Date"
                  v-model="formData.sample_ref_date"
              >
              <label for="colFormLabel" class="form-label">Pre-Costing Ref & Date: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder="Pre-Costing Ref & Date"
                  v-model="formData.pre_costing_ref_date"
              >
              <label for="colFormLabel" class="form-label">Quotation Ref & Date: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder="Quotation Ref & Date"
                  v-model="formData.quotation_ref_date"
              >
            </div>
            <div class="hidden col-md-4">
              <label for="colFormLabel" class="form-label">Order/PI No: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="text"
                  placeholder="Order/PI No"
                  v-model="formData.order_pi_no"
              >
              <label for="colFormLabel" class="form-label">Order Qty: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="text"
                  placeholder="Order Qty"
                  v-model="formData.order_qty"
              >
              <label for="colFormLabel" class="form-label">Rate: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="text"
                  placeholder="Rate"
                  v-model="formData.rate"
              >
              <label for="colFormLabel" class="form-label">Value: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="text"
                  placeholder="Value"
                  v-model="formData.value"
              >
            </div>
            <div class="col-md-4">
              <label for="colFormLabel" class="form-label">Product Costing Date: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder="Product Costing Date"
                  v-model="formData.date"
              >


              <label class="form-label">Currency</label>
              <v-select :options="currencyOptions" v-model="formData.currency" label="name"
                        :reduce="option => option.code" placeholder="Select a Currency"></v-select>
            </div>
            <div class="col-md-4">
              <label for="colFormLabel" class="form-label">Product Costing Name: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="text"
                  required
                  placeholder="Product Costing Name"
                  v-model="formData.product_costing_name"
              >
              <label for="colFormLabel" class="form-label">Total Mnf Cost: </label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="text"
                  placeholder="Costing Cost"
                  readonly
                  :value="getTotalCost"
              >
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="p-2">
      <ProductionComponentTable
          :total-cost="getTotalCost"
          type="production"
          itemType="main_product"
          tableTitle="Main Product"
          :tableItems="items.productions"
          :costingProductTypes="costingProductTypes.filter(item => item.value === 'main_product')"
      />
      <ProductionComponentTable
          :total-cost="getTotalCost"
          type="production"
          itemType="by_product"
          tableTitle="By Product"
          :tableItems="items.productions"
          class="mb-5"
          :costingProductTypes="costingProductTypes.filter(item => item.value !== 'main_product')"
      />
      <MaterialComponentTable
          type="raw_materials"
          tableTitle="A. Raw materials"
          :tableItems="items.rawMaterials"
      />
      <MaterialComponentTable
          type="packing_materials"
          tableTitle="B. Packing materials"
          :tableItems="items.packingMaterials"
      />
      <DirectComponentTable
          type="direct_labor"
          tableTitle="C. Direct Labor"
          :tableItems="items.directLabors"
      />
      <div class="card border-1">
        <div class="table-container">
          <table width="100%" class="table create-billing table-width">
            <tr class="bg-light-success">
              <th class="p-50">Prime Cost (A+B+C)</th>
              <th class="text-center">{{ getPrimeCost }}</th>
            </tr>
          </table>
        </div>
      </div>
      <DirectComponentTable
          type="direct_overhead"
          tableTitle="D. Direct Overhead"
          :tableItems="items.directOverheads"
      />
      <div class="card border-1">
        <div class="table-container">
          <table width="100%" class="table create-billing table-width">
            <tr>
              <th class="p-50">Total manufacturing cost (A+B+C+D)</th>
              <th>{{ totalManufacturingCost }}</th>
            </tr>
          </table>
        </div>
      </div>
      <div class="card border-1">
        <div class="table-container">
          <table width="100%" class="table create-billing table-width">
            <tr class="bg-light-primary">
              <th>E. General & Admin Overheads</th>
              <th class="float-end">
                <input type="text" class="form-control-sm w-50 text-center" v-model="formData.general_admin_overheads"
                       id="">
              </th>
            </tr>
          </table>
        </div>
      </div>
      <div class="card border-1">
        <div class="table-container">
          <table width="100%" class="table create-billing table-width">
            <tr class="bg-light-success">
              <th class="p-50">Total Cost (A+B+C+D+E)</th>
              <td></td>
              <th>
                {{ totalCost }}
              </th>
            </tr>
          </table>
        </div>
      </div>
      <div class="card border-1">
        <div class="table-container">
          <table width="100%" class="table create-billing table-width table-bordered">
            <tr>
              <th>Markup %</th>
              <th><input type="text" class="form-control-sm w-25 text-center" v-model="formData.markup"/> %</th>
              <th>
                {{ getMarkupAmount }}
              </th>
            </tr>
            <tr class="bg-light-primary">
              <th class="p-50">Sales price without VAT</th>
              <td></td>
              <th>
                {{ getSalePriceWithoutVat }}
              </th>
            </tr>
            <tr>
              <th>VAT</th>
              <th><input type="text" v-model="formData.vat" class="form-control-sm w-25 text-center"/> %</th>
              <th>
                {{ getVatAmount }}
              </th>
            </tr>
            <tr class="bg-light-primary">
              <th class="p-50">Sales price including VAT</th>
              <td></td>
              <th>
                {{ salesPriceIncludingVat }}
              </th>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="pb-5 px-2">
      <div class="d-flex flex-wrap gap-1 gy-2 justify-content-center">
        <div class="demo-inline-spacing text-black">
          <label class="form-check-label mt-0" for="customSwitch">Inactive</label>
          <div class="form-check form-switch mt-0">
            <input @change="customSwitch" :checked="formData.status === 'active'" type="checkbox" class="form-check-input" id="customSwitch" />
            <label class="form-check-label mt-0" for="customSwitch1">Active</label>
          </div>
        </div>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true)" class="btn btn-primary">
          Save
        </button>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(false)"
                class="btn btn-primary">Save & New
        </button>
        <button :disabled="productLoader" @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
      </div>
    </div>
    <GlobalLoader/>
    <ContactDropdownFilter
        v-if="store.state.isModalOpenThree"
        @onSearchContact="onSearchContact"
        type="supplier"
        :companyRoles="companyRoles"
    />
  </div>
</template>

<script setup>
import {computed, inject, onMounted, ref, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useStore} from "vuex";
import useDate from "@/services/utils/day";
import handleContact from '@/services/modules/contact'
import TitleButton from '@/components/atom/TitleButton'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import ProductionComponentTable
  from '@/components/molecule/company/inventory/product-costing/ProductionComponentTable.vue'
import MaterialComponentTable from '@/components/molecule/company/inventory/product-costing/MaterialComponentTable.vue'
import DirectComponentTable from '@/components/molecule/company/inventory/product-costing/DirectComponentTable.vue'
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handlePurchase from '@/services/modules/purchase'
import handleRole from "@/services/modules/role";
import handleInventory from '@/services/modules/inventory'
import handlePurchaseAndSales from "@/services/modules/purchase";

const date = useDate();
const router = useRouter()
const route = useRoute()
const store = useStore()

const showError = inject('showError');
const showSuccess = inject('showSuccess');

const {fetchSingleProductCosting, updateProductCosting, statusUpdateProductCosting, fetchCostingProductType} = handlePurchase()

const {fetchProductList} = handlePurchaseAndSales()
const {fetchContactProfiles} = handleContact()
const {formatPatientLabel} = useAsyncDropdownHelper();
const {fetchCompanyDefaultRoles} = handleRole();
const {fetchCountryOfOrigins} = handleInventory()

const companyId = computed(() => route.params.companyId)
let loader = ref(false)
let productLoader = ref(false)
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let products = ref([])
let accountHeads = ref([])
let contacts = ref([])
let business = ref([])
let locations = ref([])
let accountPayable = ref([])
let prefix = ref('')
let serial = ref('')
const discountAmount = ref(0);
const contactProfile = ref(null);
const buyerProfile = ref(null);
const companyRoles = ref([]);
const costingProductTypes = ref([]);

let formData = ref({
  company_id: companyId,
  contact_profile_id: null,
  buyer_id: null,
  product_unit: null,
  status: 'active',
  type: 'general',
  sample_ref_date: '',
  pre_costing_ref_date: '',
  quotation_ref_date: '',
  order_pi_no: '',
  order_qty: '',
  rate: '',
  value: '',
  date: '',
  bill_number: '',
  unit: '',
  currency: '',
  pre_bom_quantity: null,
  costing_qty: 1,
  product_costing_name: '',
  bom_cost: '',
  total_sales_price: '',

  productions: [],
  raw_materials: [],
  packing_materials: [],
  direct_labors: [],
  direct_overheads: [],

  general_admin_overheads: 0,
  markup: 0,
  vat: 0,
})
const items = ref({
  productions: [],
  rawMaterials: [],
  packingMaterials: [],
  directLabors: [],
  directOverheads: [],
})

const countries = ref([])
const currencyOptions = computed(() =>
    Object.values(countries.value).map(currency => ({
      code: currency.currency,
      name: currency.currency,
    }))
);

const totalProductionPercentage = computed(() => items.value.productions.reduce((acc, item) => acc + (item.wastage || 0), 0));

const getPrimeCost = computed(() => {
  const totalRawMaterialAmount = items.value.rawMaterials.reduce((total, amount) => total + parseFloat(amount.amount), 0).toFixed(4);
  const totalPackingMaterialAmount = items.value.packingMaterials.reduce((total, amount) => total + parseFloat(amount.amount), 0).toFixed(4);
  const totalDirectLaborAmount = items.value.directLabors.reduce((total, amount) => total + parseFloat(amount.amount), 0).toFixed(4);

  return (parseFloat(totalRawMaterialAmount) + parseFloat(totalPackingMaterialAmount) + parseFloat(totalDirectLaborAmount)).toFixed(4);
})

const totalManufacturingCost = computed(() => {
  const totalDirectOverheadAmount = items.value.directOverheads.reduce((total, amount) => total + parseFloat(amount.amount), 0).toFixed(4);

  return (parseFloat(getPrimeCost.value) + parseFloat(totalDirectOverheadAmount)).toFixed(4);
})

const totalCost = computed(() => (parseFloat(totalManufacturingCost.value) + parseFloat(formData.value.general_admin_overheads)).toFixed(4))
const getMarkupAmount = computed(() => ((totalCost.value * formData.value.markup) / 100).toFixed(4))
const getSalePriceWithoutVat = computed(() => (parseFloat(getMarkupAmount.value) + parseFloat(totalCost.value)).toFixed(4))
const getVatAmount = computed(() => ((getSalePriceWithoutVat.value * formData.value.vat) / 100).toFixed(4))
const salesPriceIncludingVat = computed(() => (parseFloat(getSalePriceWithoutVat.value) + parseFloat(getVatAmount.value)).toFixed(4))

const getTotalCost = computed(() => {
  const totalRawMaterialAmount = items.value.rawMaterials.reduce((total, { for_total_cost, amount }) => for_total_cost ? total + +amount : total, 0).toFixed(4);
  const totalPackingMaterialAmount = items.value.packingMaterials.reduce((total, { for_total_cost, amount }) => for_total_cost ? total + +amount : total, 0).toFixed(4);
  const totalDirectLaborAmount = items.value.directLabors.reduce((total, { for_total_cost, amount }) => for_total_cost ? total + +amount : total, 0).toFixed(4);
  const totalDirectOverheadAmount = items.value.directOverheads.reduce((total, { for_total_cost, amount }) => for_total_cost ? total + +amount : total, 0).toFixed(4);

  return (parseFloat(totalRawMaterialAmount) + parseFloat(totalPackingMaterialAmount) + parseFloat(totalDirectLaborAmount) + parseFloat(totalDirectOverheadAmount)).toFixed(4);
})

const getCostingProductType = async () => {
  await fetchCostingProductType(`?company_id=${companyId.value}`).then(({status, data}) => {
    if (!status) {
      return showError(data)
    }
    costingProductTypes.value = data;
  })
}

onMounted(() => {
  loader.value = true
  const companyQuery = `?company_id=${companyId.value}`
  const singleProductCosting = fetchSingleProductCosting(route.params.productCostingId, companyQuery)

  const getCountryOfOrigins = fetchCountryOfOrigins(companyQuery)
  Promise.all([
    getCountryOfOrigins.then(res => {
      countries.value = res.data
    }),
    fetchCompanyDefaultRoles(companyQuery).then(res => {
      if (res.data) companyRoles.value = res.data
    }),
    singleProductCosting.then(({status, data}) => {
      if (!status) {
        return;
      }
      const {general, ...rest} = data;
      formData.value = rest;
      getTotalCost.value = formData.value.bom_cost;
      contactProfile.value = formData.value.contact_profile;
      buyerProfile.value = formData.value.contact_buyer;

      general.forEach((item) => {
        if (item.type === 'production') {
          items.value.productions.push(item);
        } else if (item.type === 'raw_materials') {
          items.value.rawMaterials.push(item);
        } else if (item.type === 'packing_materials') {
          items.value.packingMaterials.push(item);
        } else if (item.type === 'direct_overhead') {
          items.value.directOverheads.push(item);
        } else if (item.type === 'direct_labor') {
          items.value.directLabors.push(item);
        }
      });

      const firstProductItem = items.value.productions.length ? items.value.productions[0] : null;
      if (firstProductItem && ! firstProductItem.product_type) {
        firstProductItem.product_type = 'main_product';
      }
    }),
    getCostingProductType()
  ]).then(() => loader.value = false).catch(() => loader.value = false)
})

watch(contactProfile, (newVal) => {
  if (!newVal) {
    return formData.value.contact_profile_id = null;
  }

  formData.value.contact_profile_id = newVal.id;
})

watch(buyerProfile, (newVal) => {
  if (!newVal) {
    return formData.value.buyer_id = null;
  }

  formData.value.buyer_id = newVal.id;
})

function navigateToListPage() {
  if (route.query.redirect_route) {
    const params = Object.assign({}, route.params, { saleMasterId: route.query.sale_master_id })
    router.push({name: route.query.redirect_route, params: params, query: route.query})
    return
  }
  router.push({name: 'product-costing-list', params: route.params, query: route.query})
}

function onOpenContactSearchModal() {
  store.state.isModalOpenThree = true;
}

function onSearchContact(contact) {
  contactProfile.value = contact
}

const customSwitch = () => {
  statusUpdateProductCosting(route.params.productCostingId, `?company_id=${companyId.value}`).then(({status, message, data})=>{
    if (!status){
      return showError(message)
    }
    formData.value.status = data;
    showSuccess(message)
  })
}

function handleSubmit(redirect = false) {
  if ((Math.round(totalProductionPercentage.value * 100) / 100) !== 100) {
    return showError('Total production percentage does not equal 100%. Please adjust the values.')
  }

  if (redirect) {
    saveButtonLoader.value = true
  } else {
    saveNewButtonLoader.value = true
  }
  formData.value.total_sales_price = salesPriceIncludingVat.value
  formData.value.bom_cost = getTotalCost.value
  formData.value.bill_number = prefix.value + '-' + serial.value
  if (!formData.value.date) formData.value.date = date.currentDate()

  formData.value.productions = items.value.productions
  formData.value.raw_materials = items.value.rawMaterials
  formData.value.packing_materials = items.value.packingMaterials
  formData.value.direct_labors = items.value.directLabors
  formData.value.direct_overheads = items.value.directOverheads
  formData.value.company_id = companyId.value
  updateProductCosting(route.params.productCostingId, formData.value).then(({status, message}) => {
    saveButtonLoader.value = false
    saveNewButtonLoader.value = false
    if (!status) {
      return showError(message)
    }

    showSuccess(message)
    if (redirect) navigateToListPage()
  }).catch(() => {
    saveButtonLoader.value = false
    saveNewButtonLoader.value = false
    productLoader.value = false
  })
}
</script>
